module.exports = __webpack_public_path__ + "static/media/capy_page_area02_img_cn@2x.6026a365.png";